<template>
     <!-- partial:partials/_navbar.html -->
     <nav class="navbar default-layout col-lg-12 col-12 p-0 fixed-top d-flex align-items-top flex-row">
      <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-start d-lg-none">
        <div class="ms-3">
          <router-link class="navbar-brand brand-logo" to="/super-admin">
            <img src="/images/logo.png" alt="logo" />
          </router-link>
        </div>
      </div>
      <div v-if="User" class="navbar-menu-wrapper d-flex align-items-top">
        <ul class="navbar-nav">
          <li class="nav-item fw-semibold d-none d-lg-block ms-0">
            <div class="d-flex align-items-center">
              <h1 class="welcome-text d-block">{{ greetingMessage }}, <span class="text-black fw-bold">{{User?.firstName +' ' + User?.lastName}}</span></h1>
              <small class="ms-3">
                <strong>Role - {{ typeof User?.role === 'string' ? User?.role : User?.role?.join(', ') }}</strong>
              </small>
            </div>
          </li>
        </ul>
        <ul class="navbar-nav ms-auto">
          <li class="nav-item"><span class="h5 text-primary super-admin-badge">Super Admin</span></li>
          <li class="nav-item dropdown user-dropdown">
            <a class="nav-link" id="UserDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
              <img v-if="User?.profileLink == ''" class="img-xs rounded-circle" src="/images/single-person.png" alt="Profile image">
              <img v-if="User?.profileLink != ''" class="img-xs rounded-circle" :src="User?.profileLink" alt="Profile image">
            </a>
            <div class="dropdown-menu dropdown-menu-right navbar-dropdown" aria-labelledby="UserDropdown">
              <div class="dropdown-header text-center">
                <!-- <img class="img-md rounded-circle" src="/images/faces/face8.jpg" alt="Profile image"> -->
                <p class="mb-1 mt-3 fw-semibold">{{User?.firstName + ' ' + User?.lastName}}</p>
                <p class="fw-light text-muted mb-0">{{User?.email}}</p>
              </div>
              <router-link to="/super-profile" class="dropdown-item">
                <i class="dropdown-item-icon mdi mdi-account-outline text-primary me-2"></i> My Profile
              </router-link>
              <a @click="logout()" class="dropdown-item">
                <i class="dropdown-item-icon mdi mdi-power text-primary me-2"></i>
                <span>Logout</span>
                <loader v-if="loader" />
              </a>
            </div>
          </li>
          <li class="nav-item d-lg-none mobile-toggle-item">
            <button
              class="navbar-toggler navbar-toggler-right"
              type="button"
              aria-label="Toggle sidebar navigation"
              @click="toggle"
            >
              <span class="mdi mdi-menu"></span>
            </button>
          </li>
        </ul>
      </div>
    </nav>
    <!-- partial -->
</template>

<script>
import loader from '../loader.vue';

export default {
  name: "HeaderPage",
  props: {
    msg: String,
  },

  components: {
        loader
    },

    data(){
        return{
            loader: false,
            currentHour: new Date().getHours(), // Gets the current hour (0-23)
        }
    },

    computed:{
      User(){
        return this.$store.state.auth.user;
      },

      greetingMessage() {
        if (this.currentHour < 12) {
          return "Good Morning";
        } else if (this.currentHour < 18) {
          return "Good Afternoon";
        } else {
          return "Good Evening";
        }
      },
    },

    methods: {
      logout(){
        this.loader = true;
        this.$store.dispatch('logout',{
          userToken: localStorage.getItem('token'),
          name: 'admin',
        })
        .then((res)=>{
            console.log("res", res);
            this.loader = false;
        })
        .catch((err)=>{
            console.log("err", err);
            this.loader = false;
        })
      },

      toggle() {
        this.$emit('toggleSidebar');
      },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.super-admin-shell .navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1030;
  background: #fff;
  box-shadow: 0 4px 20px rgba(15, 15, 20, 0.04);
}
.super-admin-shell .navbar .navbar-brand-wrapper,
.super-admin-shell .navbar .navbar-menu-wrapper {
  background: #fff;
}
.navbar-brand-wrapper .navbar-brand.brand-logo img {
  height: 56px !important;
  width: auto !important;
}
.navbar-toggler-right.navbar-toggler {
  display: flex !important;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  transition: background 0.2s ease;
}
.navbar-toggler-right.navbar-toggler .mdi-menu {
  font-size: 1.5rem;
}
.navbar-toggler-right.navbar-toggler:hover,
.navbar-toggler-right.navbar-toggler:active {
  background: rgba(0, 0, 0, 0.06);
}

/* Mobile header layout: logo pinned left (in navbar-brand-wrapper),
   hamburger toggle grouped with the profile avatar on the right (both
   are plain flex siblings in the same nav-item list, not absolutely
   positioned - the template's own .navbar-menu-wrapper width assumes
   a 55px-wide mobile logo area, and this logo box is wider than that,
   so absolute positioning was landing the avatar off in the overflow
   instead of next to the toggle). Also trims the header down from the
   desktop-height 97px band, which left a lot of empty vertical space
   on a phone screen. */
@media (max-width: 991px) {
  .navbar-brand-wrapper {
    height: 72px !important;
    width: auto !important;
    padding: 8px 16px !important;
  }
  /* The template expects a separate .brand-logo-mini element to swap
     in on mobile and hides .brand-logo outright; this header only has
     the one logo, so without this override it renders nothing here. */
  .navbar-brand-wrapper .navbar-brand.brand-logo {
    display: inline-flex !important;
    align-items: center;
  }
  .navbar-menu-wrapper {
    width: auto !important;
    flex: 1 1 auto;
    padding-top: 0 !important;
    padding-right: 16px !important;
    padding-bottom: 0 !important;
    height: 72px !important;
    align-items: center;
  }
  .mobile-toggle-item {
    margin-left: 12px;
  }
  .super-admin-badge {
    display: none;
  }
}
.super-admin-badge {
  font-size: 13px;
  font-weight: 600;
}
.user-dropdown .img-xs {
  border: 2px solid #fff;
  box-shadow: 0 0 0 2px rgba(11, 123, 120, 0.15);
  cursor: pointer;
}
.navbar-dropdown {
  border: none;
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(15, 15, 20, 0.14);
  overflow: hidden;
}
</style>
